.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  color: var(--color-foreground);
  font-size: 14px;
  font-weight: 500;
}

.error {
  color: var(--color-error);
  font-size: 13px;
}

.has-error .label {
  color: var(--color-error);
}

.has-error > div {
  border-color: var(--color-error);
}
